import createReducer from 'arts/config/create_reducer';
import Constants from '../config/const';

const getDefaultState = () => [];

const undos = createReducer(getDefaultState(), {
  [Constants.undo.push]: (state, { action }) => [...state, action],
  [Constants.undo.pop]: (state) => state.slice(0, -1)
});

export default undos;
